import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../services/api";
import { useAppointment } from "../../../context/AppointmentContext";

const Doctors = ({ search }) => {
  const [loading, setLoading] = useState(true);
  const [allDoctors, setAllDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);

  const { openAppointment } = useAppointment();

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await api.get("/api/doctors");
        setAllDoctors(response.data);
        setFilteredDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors list:", error);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    };

    fetchDoctors();
  }, []);

  useEffect(() => {
    const term = search.trim().toLowerCase();

    if (!term) {
      setFilteredDoctors(allDoctors);
      return;
    }

    const result = allDoctors.filter((doc) => {
      const haystack = [
        doc.name,
        doc.department,
        doc.designation,
        doc.qualification,
        doc.experience_years && `${doc.experience_years} years`,
        doc.expertise,
        doc.about,
        doc.learning,
        doc.awards,
        doc.services,
        doc.research
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return haystack.includes(term);
    });

    setFilteredDoctors(result);
  }, [search, allDoctors]);

  const apiUrl = process.env.REACT_APP_WEB_URL;

  return (
    <section className="doctors-list-section pb-3">
      <div className="container">
        {loading ? (
          [1, 2, 3,4].map((_, index) => (
            <div className="single-doctor-card skeleton" key={index}>
              <div className="d-flex align-items-center gap-3">
                <div className="skeleton-img shimmer"></div>
                <div className="skeleton-info">
                  <div className="skeleton-line short shimmer"></div>
                  <div className="skeleton-line medium shimmer"></div>
                  <div className="skeleton-line long shimmer"></div>
                </div>
              </div>
            </div>
          ))
        ) : filteredDoctors.length === 0 ? (
          <div className="text-center py-5">
            <p className="no-results">No doctors found matching your search.</p>
          </div>
        ) : (
          filteredDoctors.map((doc, index) => {
            const imageSrc = doc.image_url 
                ? `${apiUrl}${doc.image_url}` 
                : "/assets/img/doctors-01.png";

            return (
              <div
                className={`single-doctor-card ${
                  index === filteredDoctors.length - 1 ? "last-element" : ""
                }`}
                key={doc.id}
              >
                <div className="d-flex align-items-center gap-3">
                  <div className="single-doctor-image">
                    <img src={imageSrc} alt={doc.name} />
                  </div>
                  <div className="single-doctor-info">
                    <h3>{doc.name}</h3>
                    <div className="d-flex align-items-center gap-5 mb-lg-4">
                      <p className="single-doctor-designation mb-0">
                        {doc.designation || doc.department}
                      </p>
                      
                      {doc.experience_years && (
                        <div className="experience">
                          <span className="divider"></span>
                          <span className="years">{doc.experience_years}</span>
                        </div>
                      )}
                    </div>
                    <p className="qualifications">{doc.qualification}</p>
                  </div>
                </div>
                
                <div className="my-lg-3 ps-lg-3">
                  <div className="buttons">
                    <Link to={`/doctor/${doc.slug}`} className="btn-outline">
                      Know More
                    </Link>
                    
                    <button
                      className="btn-filled"
                      onClick={() => openAppointment(doc.name)}
                    >
                      Book Appointment
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

    </section>
  );
};

export default Doctors;
